import React from "react";

const CONTENT = {
  mentions: {
    title: "Mentions légales",
    blocks: [
      ["Éditeur du site", "Le site JC BOUTIK est édité par JC Entreprise, dont le siège est situé au 5 rue des enclos, 35350 La Gouesnière, France. Contact : contact@jcentreprise.com."],
      ["Directeur de la publication", "Le représentant légal de JC Entreprise."],
      ["Hébergement", "Le site est hébergé sur une infrastructure cloud sécurisée."],
      ["Propriété intellectuelle", "L'ensemble des contenus présents sur le site (textes, visuels, logo JC BOUTIK) est protégé par le droit de la propriété intellectuelle. Toute reproduction sans autorisation est interdite."],
      ["Données personnelles", "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour l'exercer, écrivez à contact@jcentreprise.com."],
    ],
  },
  cgv: {
    title: "Conditions Générales de Vente",
    blocks: [
      ["Article 1 — Objet", "Les présentes CGV régissent les ventes de produits proposés par JC BOUTIK sur son site internet."],
      ["Article 2 — Prix", "Les prix sont indiqués en euros, toutes taxes comprises (TTC). JC BOUTIK se réserve le droit de modifier ses prix à tout moment, les produits étant facturés sur la base des tarifs en vigueur au moment de la commande."],
      ["Article 3 — Commande", "Toute commande vaut acceptation des présentes CGV. Les produits indiqués « en rupture de stock » ne peuvent être commandés."],
      ["Article 4 — Paiement", "Le paiement s'effectue en ligne de manière sécurisée via Stripe. La commande n'est validée qu'après confirmation du paiement."],
      ["Article 5 — Livraison", "Les produits sont livrés à l'adresse indiquée lors de la commande, en France métropolitaine et au Benelux."],
      ["Article 6 — Droit de rétractation", "Conformément au Code de la consommation, vous disposez d'un délai de 14 jours pour exercer votre droit de rétractation à compter de la réception de votre commande."],
      ["Article 7 — Service client", "Pour toute question : contact@jcentreprise.com."],
    ],
  },
  livraison: {
    title: "Livraison",
    blocks: [
      ["Zones de livraison", "Nous livrons en France métropolitaine ainsi qu'en Belgique, au Luxembourg, en Suisse et à Monaco."],
      ["Délais", "Les produits en stock sont généralement expédiés sous 24 à 48h ouvrées. Le délai de livraison dépend ensuite du transporteur et de la destination (généralement 2 à 5 jours ouvrés)."],
      ["Frais de livraison", "Les frais de livraison sont calculés et affichés lors du passage en caisse, en fonction de votre adresse et du contenu de votre panier."],
      ["Suivi de commande", "Après l'expédition, un email de confirmation vous est envoyé. Les clients disposant d'un compte retrouvent l'historique de leurs commandes dans leur espace client."],
      ["Produits en rupture", "Les produits affichés « en rupture de stock » ne sont temporairement pas disponibles à la commande."],
    ],
  },
};

export default function Legal({ type }) {
  const c = CONTENT[type] || CONTENT.mentions;
  return (
    <div className="mx-auto max-w-3xl px-4 py-14 md:px-6">
      <h1 className="font-head text-3xl font-extrabold text-slate-900 md:text-4xl" data-testid="legal-title">{c.title}</h1>
      <div className="mt-8 space-y-8">
        {c.blocks.map(([h, p], i) => (
          <section key={i}>
            <h2 className="font-head text-lg font-bold text-slate-900">{h}</h2>
            <p className="mt-2 leading-relaxed text-slate-600">{p}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
